import { atom, useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const INITIAL_APPROVE_TYPE: string = "unlimited"

const userApproveTypeAtom = atomWithStorage('pcs:approve', INITIAL_APPROVE_TYPE)

const userApproveTypeAtomWithLocalStorage = atom(
  (get) => get(userApproveTypeAtom),
  (_get, set, approveType: string) => {
    set(userApproveTypeAtom, approveType)
  },
)

export const useUserApproveType = () => {
  return useAtom(userApproveTypeAtomWithLocalStorage)
}
